/**
 * Last successful /api/crm/product-types response per language (localStorage).
 * Used when offline so the measurement wizard keeps product flow + field configs.
 */
import type { ProductType } from "@shared/api";

function key(lang: string): string {
  return `tpt-product-types-snapshot-${lang}`;
}

export function saveProductTypesSnapshot(lang: string, productTypes: ProductType[]): void {
  try {
    localStorage.setItem(
      key(lang),
      JSON.stringify({ savedAt: new Date().toISOString(), productTypes }),
    );
  } catch {
    /* ignore */
  }
}

export function loadProductTypesSnapshot(lang: string): ProductType[] | null {
  try {
    const raw = localStorage.getItem(key(lang));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { productTypes?: ProductType[] };
    if (!Array.isArray(parsed.productTypes)) return null;
    return parsed.productTypes;
  } catch {
    return null;
  }
}
